var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 5.33317V4.6665M5.83331 8.33317V7.6665M5.83331 11.3332V10.6665M5.03331 13.3332H11.9666C13.0868 13.3332 13.6468 13.3332 14.0746 13.1152C14.451 12.9234 14.7569 12.6175 14.9487 12.2412C15.1666 11.8133 15.1666 11.2533 15.1666 10.1332V5.8665C15.1666 4.7464 15.1666 4.18635 14.9487 3.75852C14.7569 3.3822 14.451 3.07624 14.0746 2.88449C13.6468 2.6665 13.0868 2.6665 11.9666 2.6665H5.03331C3.91321 2.6665 3.35316 2.6665 2.92533 2.88449C2.54901 3.07624 2.24305 3.3822 2.0513 3.75852C1.83331 4.18635 1.83331 4.7464 1.83331 5.8665V10.1332C1.83331 11.2533 1.83331 11.8133 2.0513 12.2412C2.24305 12.6175 2.54901 12.9234 2.92533 13.1152C3.35316 13.3332 3.91321 13.3332 5.03331 13.3332Z",
    stroke: "#101828",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.8517531c72e06c9edd8ea99f491f2a72.svg";
export { ForwardRef as ReactComponent };